import { useState, useCallback } from 'react';

export type SortDirection = 'asc' | 'desc';

export interface SortState<T extends string = string> {
  column: T;
  direction: SortDirection;
}

/**
 * Generischer Hook fuer Sortier-State mit Toggle-Logik.
 * - Klick auf aktive Spalte wechselt Richtung
 * - Klick auf neue Spalte setzt desc als Default
 */
export function useSortState<T extends string>(
  defaultColumn: T,
  defaultDirection: SortDirection = 'desc',
) {
  const [sort, setSort] = useState<SortState<T>>({
    column: defaultColumn,
    direction: defaultDirection,
  });

  const toggleSort = useCallback(
    (column: T) => {
      setSort((prev) => {
        if (prev.column === column) {
          return {
            column,
            direction: prev.direction === 'asc' ? 'desc' : 'asc',
          };
        }
        return { column, direction: 'desc' };
      });
    },
    [],
  );

  const resetSort = useCallback(() => {
    setSort({ column: defaultColumn, direction: defaultDirection });
  }, [defaultColumn, defaultDirection]);

  return { sort, toggleSort, resetSort } as const;
}
